import {combineReducers} from 'redux';

import config from './config';
import search from './search';
import greatPlaces from './greatPlaces';
import content from './content';
import destination from './destination';
import i18n from './i18n';
import mvt from './mvt';
import linkPiles from './link-piles';
import mmgLinks from './mmg-links';
import abacus from './abacus';
import error from './error';

export const reducers = combineReducers({
    config,
    search,
    greatPlaces,
    content,
    destination,
    i18n,
    mvt,
    linkPiles,
    mmgLinks,
    abacus,
    error
});

export default reducers;
